import lptTcText from '../../lpt_TC.js'

function sectionize(text) {
  const lines = String(text || '').split(/\r?\n/).map(line => line.trim()).filter(Boolean)
  const sections = []
  let current = null
  lines.forEach(line => {
    const isHeading = line.length > 2 && line.length < 140 && line === line.toUpperCase() && /[A-Z]/.test(line)
    if (isHeading) {
      current = { title: line, paragraphs: [], list: [] }
      sections.push(current)
      return
    }
    if (!current) {
      current = { title: line, paragraphs: [], list: [] }
      sections.push(current)
    } else if (/^[•·]/.test(line)) {
      current.list.push(line.replace(/^[•·]\s*/, ''))
    } else {
      current.paragraphs.push(line)
    }
  })
  return sections
}

const termsText = lptTcText.split(/\nPRIVACY POLICY \(COOKIES AND DATA PROTECTION\)\n/)[0]
const privacyAndUsers = lptTcText.split(/\nPRIVACY POLICY \(COOKIES AND DATA PROTECTION\)\n/)[1] || ''
const privacyText = privacyAndUsers.split(/\nUSERS POLICY\n/)[0]

export default {
  termsContent: sectionize(termsText),
  privacyContent: sectionize(privacyText)
}
